import React, { useContext, useMemo } from 'react'
import { Box, MarketingLabel } from 'chemistry'
import DiscountPercentage from '../DiscountPercentage'
import gallerySelector from '../../selectors/gallery'
import { isOnlineOnly } from 'common/deliveryMode'
import { getProductName } from 'client/common/selectors/product'
import DeliveryModeLabel from 'client/fragments/productDetailsFragmentInfo/components/DeliveryModeLabel'
import EmblaCarousel from './EmblaCarousel'
import { TranslateContext } from 'client/common/translator'
import { AddToWishlistButton } from './AddToWishlistButton'

export const DetailImage = ({
  productDetails,
  lang,
  format,
  children,
  allowWishlist,
  productId,
  isGuest,
  currentLocation,
  hideVLP
}) => {
  const { images, mediaAssets, deliveryModes, offers, useMaxedaOfferAsWinner, marketingLabels } = productDetails
  const t = useContext(TranslateContext)
  const medias = useMemo(() => gallerySelector(mediaAssets || images), [images, mediaAssets])
  const showLabel = isOnlineOnly(deliveryModes, useMaxedaOfferAsWinner, offers)
  const name = getProductName(productDetails)
  const [marketingLabel] = Array.isArray(marketingLabels) ? marketingLabels : []

  const slides = medias.map((item, index) => ({
    type: item.type,
    url: item.src || item.video?.source?.[0]?.src,
    alt: `${name} ${index === 0 ? '' : index + 1}`.trim(),
    bigUrl: item.src?.replace('424x424', '1400x1400') || item?.video?.source,
    smallUrl: item.thumb
  }))

  return (
    <div className='mxd-product-detail-layout-product mxd-product-detail-layout-image'>
      <DiscountPercentage product={productDetails} lang={lang} format={format} hideVLP={hideVLP} />
      {allowWishlist && (
        <AddToWishlistButton
          productDetails={productDetails}
          currentLocation={currentLocation}
          isGuest={isGuest}
          productId={productId}
          format={format}
          lang={lang}
          t={t}
        />
      )}
      <EmblaCarousel slides={slides} options={{}} lang={lang} />
      {showLabel && (
        <div className='mxd-product-detail-layout-product-meta'>
          <DeliveryModeLabel deliveryMode={t('deliveryMode_exclusive')} position={marketingLabel ? 'left' : 'right'} />
        </div>
      )}
      {marketingLabel && (
        <Box className='mxd-promotion-label'>
          <MarketingLabel
            labelText={marketingLabel?.labelText}
            url={marketingLabel?.url}
            metadata={{
              ...(hideVLP ? { textColor: 'yellow.500' } : {}),
              ...(marketingLabel?.metadata || {})
            }}
            sizes={['lg']}
          />
        </Box>
      )}
      {children}
    </div>
  )
}

export default DetailImage
